:host {
  display: block;
  width: 100%;
  height: 100%;
  iframe {
    max-width: var(--chat-message-max-width);
    height: var(--video-height);
  }
}
